<section [style.min-height.px]="mobileHeight()">
  @if (imageLoaded()) {
    @if (data().video; as video) {
      <div [style.height.px]="desktopHeight()" class="video-wrapper">
        <app-video
          [autoplay]="true"
          [cover]="true"
          [isLoop]="video.isLoop ?? true"
          [isMuted]="video.isMuted ?? true"
          [mp4Url]="video.mp4Url"
          [previewImage]="video.image" />
      </div>
    } @else if (data().image) {
      <app-image [image]="data().image!" [size]="{ dh: desktopHeight(), mh: mobileHeight() }" />
    }
  }
</section>
